import _ from 'underscore';
import $ from 'jquery';
import Backbone from 'backbone';
import Globalize from 'globalize';
// import 'jquery-hotkeys';
import app from '../../app';

export default Backbone.View.extend({

    events: {
        'change #selectPortalCustomerSelect': 'onSelectPortalCustomerSelect'
    },

    initialize: function () {
        this.container = this.$('.nav-container');
        this.brand = this.container.children('.navbar-brand');
        this.left = this.container.find('.navbar-left');
        this.right = this.container.find('.navbar-right');

        this.initShoppingCart(); //button
        this.initProductComparison(); //button

        if (!app.config.legacyBrowser) {
            this.initCategories();
            this.initProductComparisonList();
            this.initShoppingCartDetails();
            this.initPortalCustomer();
            if (!app.config.ociMode) {
                this.initUser();
            }
        }

        this.initFixedNavigation();
        this.initKeyboardShortcuts();
    },

    initCategories: function () {
        if (!_.contains($.Mustache.templates(), 'navigation-categories') || !_.contains($.Mustache.templates(), 'navigation-divider')) {
            return;
        }

        this.left.append($.Mustache.jQ('navigation-divider'));
        this.left.append($.Mustache.jQ('navigation-categories'));
    },

    initProductComparison: function () {
        if (app.view.header.productComparison === null) {
            return;
        }

        const headerProductComparison = app.view.header.productComparison;
        headerProductComparison.on('refresh', this.refreshProductComparisonStatus, this);
        const productComparison = $.Mustache.jQ('navigation-product-comparison');
        this.right.prepend(productComparison);
        this.refreshProductComparisonStatus();
    },

    initProductComparisonList: function () {
        if (app.view.header.productComparison === null) {
            return;
        }

        const headerProductComparison = app.view.header.productComparison;
        headerProductComparison.on('refresh', this.refreshProductComparison, this);
        this.refreshProductComparison();
    },

    initShoppingCart: function () {
        if (app.view.header.shoppingCart === null) {
            return;
        }

        const headerShoppingCart = app.view.header.shoppingCart;
        headerShoppingCart.on('refresh', this.refreshShoppingCartStatus, this);
        const shoppingCart = $.Mustache.jQ('navigation-shopping-cart');
        this.right.prepend(shoppingCart);

    },

    initShoppingCartDetails: function () {
        if (app.view.header.shoppingCart === null) {
            return;
        }

        const headerShoppingCart = app.view.header.shoppingCart;
        headerShoppingCart.on('refresh', this.refreshShoppingCart, this);
        this.refreshShoppingCart();
    },

    initPortalCustomer: function () {
        if (!_.contains($.Mustache.templates(), 'navigation-portalcustomer')) {
            return;
        }

        this.right.prepend($.Mustache.jQ('navigation-portalcustomer'));
    },

    initUser: function () {
        if (!_.contains($.Mustache.templates(), 'navigation-user-dropdown-menu') || this.right.children('.user').length === 0) {
            return;
        }

        const userDropDownMenu = $.Mustache.jQ('navigation-user-dropdown-menu');
        const user = this.right.children('.user');
        user.addClass('dropdown').append(userDropDownMenu);
        user
            .children('a')
            .addClass('dropdown-toggle')
            .removeAttr('href')
            .attr({
                'data-toggle': 'dropdown',
                'data-target': '#',
                href: '#'
            })
            .append($('<b>').addClass('caret'));
    },

    initFixedNavigation: function () {
        $(window).scroll(this.updateState);
        $(window).resize(this.updateState);

        this.updateState();
    },

    initKeyboardShortcuts: function () {
        //$(document).bind('keydown', 'shift+q', _.bind(this.onKeyLogout, this));
    },

    onKeyLogout: function () {
        const logout = this.right.children('.logout');
        if (logout.length > 0) {
            window.location.href = logout.children('a').attr('href');
        }
    },

    getState: function () {
        return this.$el.hasClass('navbar-fixed-top') ? 'fixed' : 'default';
    },

    updateState: function () {
        const appView = app.view;
        const navigation = this.$el ? this : appView.navigation;

        const verticalPosition = $(window).scrollTop();
        const headerMenuHeight = (appView.$('#header').length > 0) ? appView.$('#header').height() : 0;

        $.fx.off = true;
        if (verticalPosition > headerMenuHeight) {
            if (!navigation.$el.hasClass('navbar-fixed-top')) {
                navigation.brand.hide();
                navigation.$el
                    .hide()
                    .addClass('navbar-fixed-top')
                    .show();
                navigation.left.fadeIn();
                navigation.right
                    .children('.product-comparison, .shopping-cart, .divider-vertical')
                    .fadeIn();

                if (app.config.legacyBrowser) {
                    $('nav.navbar .navbar-right li > a').css('color', $('nav.navbar .navbar-right li > a').css('color'));
                    $('nav.navbar .navbar-right li > a').css('color', '');
                }
            }
        } else {
            navigation.$el.removeClass('navbar-fixed-top');
            navigation.brand.fadeIn();
            navigation.left.hide();
            navigation.right
                .children('.product-comparison, .shopping-cart, .divider-vertical')
                .hide();
        }
        $.fx.off = false;
    },

    refreshShoppingCartStatus: function () {
        const link = this.getShoppingCart().children('a');
        const shoppingCartItems = app.getShoppingCart().get('shoppingCartItems');
        const shoppingCartStatus = `${Globalize.localize('shoppingCart')} (${shoppingCartItems.length})`;
        link
            .contents()
            .eq(1)
            .replaceWith(document.createTextNode(shoppingCartStatus));
    },

    refreshShoppingCart: function () {
        if (!_.contains($.Mustache.templates(), 'navigation-shopping-cart') ||
            !_.contains($.Mustache.templates(), 'navigation-divider') ||
            _.isNull(app.view.header.shoppingCart)
        ) {
            return;
        }

        const shoppingCart = this.right.children('.shopping-cart');

        // clone details overlay from header and append it
        const { details } = app.view.header.shoppingCart;
        const shoppingCartItems = app.getShoppingCart().get('shoppingCartItems');

        if (shoppingCartItems.length > 0) {
            shoppingCart.addClass('dropdown');

            const link = shoppingCart.children('a');
            link
                .addClass('dropdown-toggle')
                .removeAttr('href')
                .attr({
                    'data-toggle': 'dropdown',
                    'data-target': '#',
                    href: '#'
                });

            if (link.children('b').length === 0) {
                const caret = $('<b>').addClass('caret');
                link.append(caret);
            }

            // IE8 has problems cloning DOM structures containing HTML5 elements
            // so we use this workaround to create a copy of the shopping cart DIV
            // see http://stackoverflow.com/questions/15708937/ie7-8-time-tag-jquery-clone
            const div = document.createElement('div');
            div.innerHTML = details.html();
            const clonedDetails = $(div)
                .addClass('shopping-cart-details')
                .addClass('header-status-list');
            // var clonedDetails = details.clone();

            shoppingCart.find('.dropdown-menu').remove();
            shoppingCart.append(clonedDetails.addClass('dropdown-menu'));

            clonedDetails.css('display', '');
            clonedDetails.find('.slimScrollDiv > ul').unwrap();
            clonedDetails.find('.slimScrollBar').remove();
            clonedDetails.find('.slimScrollRail').remove();
            clonedDetails.find('ul').slimScroll({ height: `${app.view.header.shoppingCart.getScrollingHeight()}px` });
        }
    },

    getShoppingCart: function () {
        return this.right.children('.shopping-cart');
    },

    refreshProductComparisonStatus: function () {
        const link = this.getProductComparison().children('a');
        const productComparisonList = app.getProductComparisonList();
        const productComparisonStatus = `${Globalize.localize('productComparison')} (${productComparisonList.length})`;
        link
            .contents()
            .eq(1)
            .replaceWith(document.createTextNode(productComparisonStatus));
    },

    refreshProductComparison: function () {
        if (!_.contains($.Mustache.templates(), 'navigation-product-comparison') ||
            !_.contains($.Mustache.templates(), 'navigation-divider') ||
            _.isNull(app.view.header.productComparison)
        ) {
            return;
        }

        const productComparison = this.right.children('.product-comparison');

        // clone details overlay from header and append it
        const { details } = app.view.header.productComparison;
        const productComparisonList = app.getProductComparisonList();

        if (productComparisonList.length > 0) {
            productComparison.addClass('dropdown');

            const link = productComparison.children('a');
            link
                .addClass('dropdown-toggle')
                .removeAttr('href')
                .attr({
                    'data-toggle': 'dropdown',
                    'data-target': '#',
                    href: '#'
                });

            if (link.children('b').length === 0) {
                const caret = $('<b>').addClass('caret');
                link.append(caret);
            }

            // IE8 has problems cloning DOM structures containing HTML5 elements
            // so we use this workaround to create a copy of the shopping cart DIV
            // see http://stackoverflow.com/questions/15708937/ie7-8-time-tag-jquery-clone
            const div = document.createElement('div');
            div.innerHTML = details.html();
            const clonedDetails = $(div)
                .addClass('product-comparison-list')
                .addClass('header-status-list');
            // var clonedDetails = details.clone();

            productComparison.find('.dropdown-menu').remove();
            productComparison.append(clonedDetails.addClass('dropdown-menu'));

            clonedDetails.find('.btn-primary').click(
                (event) => {
                    event.preventDefault();
                    app.view.header.productComparison.showProductComparison();
                }
            );

            clonedDetails.css('display', '');
            clonedDetails.find('.slimScrollDiv > ul').unwrap();
            clonedDetails.find('.slimScrollBar').remove();
            clonedDetails.find('.slimScrollRail').remove();
            clonedDetails.find('ul').slimScroll({ height: `${app.view.header.productComparison.getScrollingHeight()}px` });
        }
    },

    getProductComparison: function () {
        return this.right.children('.product-comparison');
    },

    onSelectPortalCustomerSelect: function () {
        const selectedIndex = this.$('#selectPortalCustomerSelect').prop('selectedIndex');

        if (selectedIndex !== 0) {
            this.$('#savePortalCustomerModal').prop('disabled', false);
        } else {
            this.$('#savePortalCustomerModal').prop('disabled', true);
        }
    }
});



// WEBPACK FOOTER //
// ./views/layout/NavigationElementController.js